// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"42e83c59","591":"423f7127","680":"ee8a57a9","900":"8cf64654"}[chunkId] + ".chunk.js";
};